import { FlowType } from '@front/common/types'

// TODO : Remove after ab testing on transition pages finished
import abTestTransitionSteps from './abTestingTransition'
import classicSteps from './classic'
import creationSteps from './creation.steps'
import editingSteps from './editing.steps'

export default {
  [FlowType.classic]: classicSteps,
  // TODO : Remove after ab testing on transition pages finished
  [FlowType.transition]: abTestTransitionSteps,
  [FlowType.creation]: creationSteps,
  [FlowType.update]: editingSteps,
}
